import * as React from 'react';

import {AttachmentList} from '../../../attachment-list/attachment-list';
import type {Attachment} from '../../../attachment-list/types';
import {IconButton} from '../../../button/icon-button/icon-button';
import {EyeIcon} from '../../../icon/svg/eye-icon';
import {LinkClickIcon} from '../../../icon/svg/link-click-icon';
import {PaperClipRegularDiagonalIcon} from '../../../icon/svg/paper-clip-regular-diagonal-icon';
import {Popover} from '../../../popover/popover';

import styles from './left-side.module.css';

// EmailEngagementProps
export type Props = {
    attachments: Attachment[];
    opens: number;
    clicks: number;
};

export const EmailEngagement = (props: Props) => {
    const {attachments, opens, clicks} = props;
    const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);
    const popoverAnchor = React.useRef();

    return (
        <>
            <div className='flex'>
                {attachments.length > 0 ? (
                    <IconButton
                        icon={PaperClipRegularDiagonalIcon}
                        text={attachments.length}
                        onClick={() => {
                            setIsPopoverOpen(true);
                        }}
                        getButtonRef={popoverAnchor}
                        noHoverBackground={true}
                        tooltipText={`${attachments.length} ${
                            attachments.length > 1 ? 'attachments' : 'attachment'
                        }`}
                    />
                ) : undefined}
                {opens > 0 ? (
                    <div
                        data-tip={opens === 1 ? '1 open' : `${opens} opens`}
                        className={styles.container}
                    >
                        <EyeIcon size={17} wrapWithDiv={false} />
                        <span className={styles.count}>{opens}</span>
                    </div>
                ) : undefined}
                {clicks > 0 ? (
                    <div
                        data-tip={clicks === 1 ? '1 click' : `${clicks} clicks`}
                        className={styles.container}
                    >
                        <LinkClickIcon size={17} wrapWithDiv={false} />
                        <span className={styles.count}>{clicks}</span>
                    </div>
                ) : undefined}
            </div>
            {isPopoverOpen ? (
                <Popover
                    anchor={popoverAnchor.current}
                    location='bottom'
                    onBlur={() => {
                        setIsPopoverOpen(false);
                    }}
                >
                    <AttachmentList attachments={attachments} />
                </Popover>
            ) : undefined}
        </>
    );
};
